import { gql } from '@apollo/client';

export const groupsQuery = gql`
  query ($inAcessMoveis: InAcessMoveis!) {
    groupsProducts(inAcessMoveis: $inAcessMoveis) {
      productGroupId
      productGroupName
    }
  }
`;
